export const fastPredictableHash = (input, charRange = 'abcdefghijklmnopqrstuvwxyz') => {
  // Quick return for empty input
  if (!input) return charRange[0];

  // Precompute charRange length to avoid repeated calculation
  const rangeLength = charRange.length;

  // Use bitwise operations and a mix of prime multipliers for faster computation
  let hash = 5381; // Known good starting prime number

  // Unrolled loop for better performance
  for (let i = 0; i < input.length; i++) {
    // Use bitwise left shift and addition for faster multiplication
    // Number of iterations minimized to reduce computational overhead
    hash = (hash << 5) + hash + input.charCodeAt(i);

    // Keep hash within 32-bit integer range to prevent overflow
    hash = hash & 0x7fffffff;
  }

  // Use bitwise AND for faster modulo operation
  return charRange[hash % rangeLength];
};

export const isAttachment = (roomName) => roomName.startsWith('attachments/');

// magic markers to signify an object or an array
const COLLAB_OBJECT_MARKER = '5d60f178377e';
const COLLAB_ARRAY_MARKER = 'eab499415ccc';
const COLLAB_SEPARATOR_MARKER = '14f426b6';
const COLLAB_ARRAY_ID_PREFIX = 'g~~~';

export const _flattenObject = (obj, prefix = '__') => {
  const result = {};
  let keys = [];
  let okeys = [];
  if (Array.isArray(obj)) {
    keys = obj.map((_item, i) => i);
    okeys = obj.map((item, i) =>
      item?.id === undefined ? i : `${COLLAB_ARRAY_ID_PREFIX}${item.id}`
    );
    result[prefix] = COLLAB_ARRAY_MARKER;
  } else if (typeof obj === 'object') {
    keys = obj === null ? [] : Object.keys(obj);
    okeys = obj === null ? [] : Object.keys(obj);
    result[prefix] = obj === null ? null : COLLAB_OBJECT_MARKER;
  } else {
    result[prefix] = obj;
  }
  for (let i = 0; i < keys.length; i++) {
    const key = keys[i];
    const okey = okeys[i];
    const newKey =
      prefix !== '__' ? `${prefix}${COLLAB_SEPARATOR_MARKER}${okey}` : `__${okey}`;
    if (typeof obj[key] === 'object') {
      Object.assign(result, _flattenObject(obj[key], newKey));
    } else if (obj[key] !== undefined) {
      result[newKey] = obj[key];
    }
  }
  return result;
};

export const _expandObject = (flatObj) => {
  let result;
  const sorted = Object.keys(flatObj);
  const convertValue = (val, part) => {
    if (val === COLLAB_OBJECT_MARKER) {
      if (part && part.startsWith && part.startsWith(COLLAB_ARRAY_ID_PREFIX)) {
        return {id: part.substring(COLLAB_ARRAY_ID_PREFIX.length)};
      } else {
        return {};
      }
    } else if (val === COLLAB_ARRAY_MARKER) {
      return [];
    } else {
      return val;
    }
  };
  const getKey = (current, part) => {
    if (!Array.isArray(current)) {
      return part;
    } else if (
      current.length > 0 &&
      (`${COLLAB_ARRAY_ID_PREFIX}${current[current.length - 1]?.id}` === part ||
        `${current.length - 1}` === part)
    ) {
      return current.length - 1;
    } else if ((/^\d+$/.test(part) && !/^0+/.test(part)) || part == '0') {
      //part is just digits w/o leading 0s
      return part;
    } else {
      return current.length;
    }
  };
  sorted.sort((a, b) => a.localeCompare(b));
  for (const key of sorted) {
    if (key === '__') {
      result = convertValue(flatObj[key], key);
      continue;
    }
    const parts = key.substring(2).split(COLLAB_SEPARATOR_MARKER);
    let current = result;
    for (let i = 0; i < parts.length - 1; i++) {
      if (!current) continue;
      current = current[getKey(current, parts[i])];
    }
    if (!current) continue;

    current[getKey(current, parts[parts.length - 1])] = convertValue(
      flatObj[key],
      parts[parts.length - 1]
    );
  }
  return result;
};

export const generateTimeId = () => {
  const timestamp = Date.now();
  const randomBytes = new Uint8Array(8);
  self.crypto.getRandomValues(randomBytes);
  const randomHex = Array.from(randomBytes)
    .map((b) => b.toString(16).padStart(2, '0'))
    .join('');
  return `g${timestamp}-${randomHex}`;
};

export const collaborationLog = (message, err) => {
  const dt = new Date().toISOString().split('.');
  const msg = `[app-collaboration ${dt[0]}.${(dt[1] || '').padStart(3, '0')}] ${message}`;
  if (err) {
    console.error(msg, err);
  }
};
